import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { type JSX } from "react";
import Dropzone from "react-dropzone";

import {
  CentralContentWrapper,
  DropzoneContainer,
  MaxSizeDiv,
} from "./FileUploaderDropzone.styles";
import { FileUploaderStatus } from "./FileUploaderStatus";
import { UploadedFile } from "./UploadedFile";
import { useFileUploaderDropzoneState } from "./useFileUploaderDropzoneState";

export interface IFileUploaderDropzoneProps {
  onUploadSuccess: (file: File) => Promise<void>;
  onUploadError: (error: string) => void;
  onRemoveFile: () => void;
  maxFileSize: number;
  accepts: string;
  strictLocalize: StrictLocalizeFunction;
  currentFile?: File;
  height?: number;
  width?: number;
  loading?: boolean;
  error?: boolean;
  uploadCta?: string | JSX.Element;
  showFileIcon?: boolean;
}

export const FileUploaderDropzone: React.FC<IFileUploaderDropzoneProps> = (
  props
) => {
  const state = useFileUploaderDropzoneState(props);
  const { currentFile, loading, onRemoveFile, showFileIcon } = props;

  if (state.showChosenFile) {
    return <UploadedFile file={currentFile as File} onRemove={onRemoveFile} />;
  }

  return (
    <Dropzone
      accept={props.accepts}
      maxSize={props.maxFileSize}
      multiple={false}
      onDrop={state.handleDropResult}
    >
      {({ getRootProps, getInputProps }) => (
        <DropzoneContainer
          height={props.height}
          width={props.width}
          error={state.showUploadError ? state.showUploadError : undefined}
        >
          <MaxSizeDiv {...getRootProps()}>
            <label htmlFor="fileUploader" style={{ display: "none" }}>
              <StrictLocalMsg defaultMessage="File Uploader" />
            </label>
            <input {...getInputProps()} id="fileUploader" />
            <CentralContentWrapper color={state.iconColor}>
              <FileUploaderStatus
                uploadCta={props.uploadCta}
                isLoading={loading}
                error={state.showUploadError}
                showFileIcon={showFileIcon}
              />
            </CentralContentWrapper>
          </MaxSizeDiv>
        </DropzoneContainer>
      )}
    </Dropzone>
  );
};
